// We're using babel-polyfill to polyfill older browsers with modern ES6 features
// such as Promise and Array / Object functions
import 'babel-polyfill';

require('../shared/bootstrap');

// Config
Vue.config.debug = true;
Vue.config.errorHandler = function (err, vm) {
  // handle error
  console.log(err);
}


// Vuex Store
import store from './store';


// Router
import router from './router';


// Custom plugin to handle localization translations
import Speak from '@/shared/plugins/speak';
Vue.use(Speak);


// Directives
import focus from '@/shared/directives/focus';
import blur from '@/shared/directives/blur';

Vue.directive('focus', focus);
Vue.directive('blur', blur);


// Components
import Toasts from '@/shared/components/Toasts.vue';

const App = new Vue({
  el: '#external',

  store,
  router,

  components: {
    Toasts
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/external/external.js